import React from 'react';

import './style.scss';

type ThemedActionIconName =
  | 'bulkUpload'
  | 'customizeColumns'
  | 'document'
  | 'download'
  | 'filter'
  | 'filterClose'
  | 'gridXmark'
  | 'lock'
  | 'logout'
  | 'users';

interface ThemedActionIconProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  name: ThemedActionIconName;
  standalone?: boolean;
}

const ThemedActionIcon: React.FC<ThemedActionIconProps> = ({
  name,
  className = '',
  standalone = false,
  ...spanProps
}) => (
  <span
    aria-hidden='true'
    className={`themed-action-icon themed-action-icon--${name}${
      standalone ? ' themed-action-icon--standalone' : ''
    }${className ? ` ${className}` : ''}`}
    {...spanProps}
  />
);

export default ThemedActionIcon;
